import * as React from 'react';
import { ChartQuadrant } from './ChartQuadrant';
import { ChartBar } from './ChartBar';
import { PriceSummary } from './PriceSummary';

import { ChartLine } from './ChartLine';
import { ERPApiResult } from '~/libs/infrastructure/schemas/erp';
import { VirtualPackErpResponse } from 'com.cogvio.pricemonitor.api';

interface BaseScenarioProps {
	currency: string;
	erpModelResult: VirtualPackErpResponse;
	parseErpResults: ERPApiResult;
	virtualProductPackName: string;
	onDataAddRequest: () => void;
}

export function BaseScenario({
	currency,
	erpModelResult,
	parseErpResults,
	virtualProductPackName,
	onDataAddRequest,
}: BaseScenarioProps) {
	return (
		<div className='px-10 bg-white'>
			<div className='relative py-5 w-full max-w-7xl mx-auto border-b border-gray-200'>
				<h2 className='mb-1 font-display text-h3 font-semibold text-cPurple-600'>Base Scenario</h2>

				<PriceSummary
					currency={currency}
					monthData={erpModelResult.monthData}
					cumulativeRevenues={erpModelResult.stats.cumulativeRevenues}
				/>
				<div className='pt-2 flex justify-between w-full'>
					<div className='w-1/2 pr-2'>
						<ChartQuadrant currency={currency} parseErpResults={parseErpResults} />
					</div>
					<div className='w-1/2 pl-2'>
						<ChartBar currency={currency} parseErpResults={parseErpResults} onDataAddRequest={onDataAddRequest} />
					</div>
				</div>
				<ChartLine result={parseErpResults} virtualProductPackName={virtualProductPackName} />
			</div>
		</div>
	);
}
